import React from "react";
import "../styles/Contact.css";
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiFacebook,
  FiTwitter,
  FiInstagram,
  FiYoutube,
  FiSend
} from "react-icons/fi";

const Contact = () => {
  return (
    <div>
      <section className="contact-wrapper">
        {/* Header */}
        <div className="contact-header">
          <h2>Get in Touch</h2>
          <p>தொடர்பு கொள்ள</p>
        </div>

        {/* Info Cards */}
        <div className="contact-cards">
          <div className="contact-card">
            <span className="icon-circle12">
              <FiMapPin />
            </span>
            <h4>Visit Us</h4>
            <p>எங்களைச் சந்திக்கவும்</p>
            <span className="card-text">
              Pin -637502
            </span>
          </div>

          <div className="contact-card">
            <span className="icon-circle12">
              <FiPhone />
            </span>
            <h4>Call Us</h4>
            <p>எங்களை அழைக்கவும்</p>
            <span className="card-text">9176995369
            </span>
            <span className="card-text">
              9894081162</span>
          </div>

          <div className="contact-card">
            <span className="icon-circle12">
              <FiMail />
            </span>
            <h4>Email Us</h4>
            <p>மின்னஞ்சல் செய்யவும்</p>
            <span className="card-text">bjpsudharadhakrishnan <br /> 2025@gmail.com.</span>
          </div>
        </div>

        {/* Social Icons */}
        <div className="social-icons">
          <span><FiFacebook /></span>
          <span><FiTwitter /></span>
          <span><FiInstagram /></span>
          <span><FiYoutube /></span>
        </div>

        {/* Message Form */}
        <div className="message-section">
          <div className="message-card">
            <h3>Send us a Message</h3>
            <p>எங்களை அணுகவும்</p>

            <div className="form-group">
              <label>Name / பெயர்</label>
              <input type="text" placeholder="Your Full Name" />
            </div>

            <div className="form-group">
              <label>Mobile Number / கைபேசி எண்</label>
              <input type="text" placeholder="10-digit Mobile Number" />
            </div>

            <div className="form-group">
              <label>Message / செய்தி</label>
              <textarea placeholder="How can we help you?" />
            </div>

            <button className="submit-btn">
              Submit Message <FiSend />
            </button>
          </div>
        </div>
      </section>
      <section className="join-wrapper">
        {/* Map Placeholder */}
        <div className="map-container">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12947.67815908357!2d78.07194967956009!3d11.584688839058982!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babe5b6f42b47e7%3A0x3231444b6fc88a91!2sVeerapandi%2C%20Tamil%20Nadu%20636308!5e1!3m2!1sen!2sin!4v1769151357128!5m2!1sen!2sin" width="100%"
            height="450" style={{ border: 0, borderRadius: "20px" }}
            allowFullScreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"
            title="Virapandi Location"></iframe>
        </div>

        {/* CTA Section */}
        <div className="cta-container">
          <h2>Join BJP for a Stronger and Prosperous India</h2>
          <p>
            வளமான மற்றும் வலிமையான இந்தியாவிற்காக பாஜகவில் இணையுங்கள்
          </p>
          <button className="cta-btn">Become a Member Today</button>
        </div>
      </section>
    </div>
  )
}

export default Contact